import { render, staticRenderFns } from "./TaxBaseVariableForm.vue?vue&type=template&id=4748b725&scoped=true&"
import script from "./TaxBaseVariableForm.vue?vue&type=script&lang=ts&"
export * from "./TaxBaseVariableForm.vue?vue&type=script&lang=ts&"
import style0 from "./TaxBaseVariableForm.vue?vue&type=style&index=0&id=4748b725&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4748b725",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4748b725')) {
      api.createRecord('4748b725', component.options)
    } else {
      api.reload('4748b725', component.options)
    }
    module.hot.accept("./TaxBaseVariableForm.vue?vue&type=template&id=4748b725&scoped=true&", function () {
      api.rerender('4748b725', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TaxBaseVariable/TaxBaseVariableForm.vue"
export default component.exports